<template>
    <div class="subtitle">
        <div>{{ selectedSite?.description }}</div>
    </div>
    <div class="form-container">
        <div class="form-title">
            {{ $t('reclamation.description.title') }}
        </div>
        <div class="description-container" :class="error ? 'description-container-error' : ''">
            <textarea
                @focus="this.focus = true"
                @blur="handleBlur"
                class="description-input"
                v-model="inputValue"
                name="description"
                @input="handleInput"
            />
            <span class="label" :class="`${error ? 'label-error' : ''} ${focus || inputValue ? 'label-active' : ''}`">
                {{ $t('reclamation.description.label') }}
            </span>
        </div>
        <div class="error-container">
            <span>
                {{ error }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Site } from '@/models/Site';

interface Data {
    focus: boolean;
    error?: string;
    inputValue: string;
}

export default defineComponent({
    data(): Data {
        return {
            focus: false,
            inputValue: '',
        };
    },
    methods: {
        handleBlur() {
            this.inputValue = this.inputValue.trim();
            this.$emit('description', this.inputValue);
            this.focus = false;
            if (this.inputValue.length !== 0 && !this.isValid()) this.error = this.$t('reclamation.description.error');
        },
        handleInput() {
            this.error = undefined;
            this.$emit('description', this.inputValue);
        },
        isValid() {
            return this.inputValue.trim().length > 0;
        },
    },
    props: {
        selectedSite: {
            type: Object as PropType<Site>,
            required: true,
        },
    },
});
</script>

<style scoped>
.form-container {
    margin-top: 8px;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    padding: 16px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
}
.description-container {
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    height: 250px;
    width: 500px;
    border-radius: 4px;
    padding: 11px 12px;
}
.description-container-error {
    border-color: var(--color-danger);
}
.label {
    position: absolute;
    left: 12px;
    top: 8px;
    transition: 0.2s ease all;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    padding: 2px;
    font-size: var(--font-size-low-medium);
}
.label-active {
    top: -7px;
    font-size: var(--font-size-very-small);
}
.label-error {
    color: var(--color-danger);
}
.description-input {
    flex: 1;
    border: none;
    resize: none;
    outline: none;
}
.error-container {
    color: var(--color-danger);
    padding-top: 9px;
    padding-left: 12px;
    font-size: var(--font-size-very-small);
    font-weight: 400;
    line-height: 12px;
    height: 21px;
}
.form-title {
    font-size: var(--font-size-medium);
    font-weight: 500;
    line-height: 20px;
    color: var(--color-principal);
    margin-bottom: 16px;
}
.contract-label {
    font-size: 12px;
}
</style>
